import config from "./config";
import type { ElearningTheme } from "./themes/elearning.theme";
import { legacyTheme } from "./themes/legacy";

interface Themes {
  legacy: ElearningTheme;
  [key: string]: ElearningTheme;
}

const themes: Themes = {
  legacy: legacyTheme,
};

export const theme: ElearningTheme = themes[config.theme];
